import ChangeHistory from '@mui/icons-material/ChangeHistory';

const PolygonIcon = (): JSX.Element => (
  <ChangeHistory data-testid="polygon-icon" fontSize="inherit" />
);

export default PolygonIcon;
